/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
   // check if product-block-list exists
  var x = document.getElementsByClassName("product-block-list");
  if (x.length == 1){ // only 1 element found, we are on a product page
  	var button_check = document.getElementsByClassName("contactButton");
    button_check[0].classList.add("hide_elem"); // HIDE first button
    var button_request = document.getElementsByClassName("contactButtonRequest");
    button_request[0].classList.remove("hide_elem"); // toogle request button
    
    
    button_request[0].addEventListener('click', function(event){
    event.preventDefault();
	var requestForm = document.getElementsByClassName("productRequestForm");
    requestForm[0].classList.toggle("hide_elem");
	});
    
  }
})();

